import { render } from "./CardForm.vue?vue&type=template&id=58921a5b&ts=true"
import script from "./CardForm.vue?vue&type=script&lang=ts"
export * from "./CardForm.vue?vue&type=script&lang=ts"

import "./CardForm.vue?vue&type=style&index=0&id=58921a5b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__